var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasAbstained)?_c('v-icon',{attrs:{"x-large":"","color":"teal darken-2"}},[_vm._v(_vm._s(_vm.votingStates.abstained))]):_c('span',[_vm._v(_vm._s(_vm.value))])}
var staticRenderFns = []

export { render, staticRenderFns }